import React from 'react'
import PropTypes from 'prop-types'
import { Indicator, Measure, LocalizedText } from 'labguard-cdk'
import { DeviationIcon } from 'src/components/common'
import ThresholdInput from './ThresholdInput'

const EmtIndicator = ({ unit, value, color, onChange, disabled, ...props }) => (
  <Indicator
    {...props}
    icon={DeviationIcon}
    separator
    title={
      <Measure unit={unit} color={color}>
        <ThresholdInput min={0} step={0.5} value={value} onChange={onChange} disabled={disabled} />
      </Measure>
    }
    subtitle={<LocalizedText id="WEB_EMT" />}
    color={color}
    height="1.875rem"
  />
)

EmtIndicator.defaultProps = {
  value: '',
}

EmtIndicator.propTypes = {
  unit: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  color: PropTypes.string,
  onChange: PropTypes.func,
}

export default EmtIndicator
